import React, { useEffect, useState } from "react";
import AdminCommonComponent from "../../components/AdminCommonComponent";
import styles from "./adminsettings.module.css";
import { PaymentGatewayAPI } from "../../../../App/api/setting";
import GradientButton from "../../../../Components/Button/GradientButton";
import { Form, Formik } from "formik";
import { FormField } from "../../../../Components/FormField";
import TextInput from "../../../../Components/TextInput";
import ToggleButton from "../../../../Components/ToggleButton/ToggleButton";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import ConfirmPopup from "../../../../Components/ConfirmPopup";

const PaymentGateway = () => {
const { value, fetchAllData } = useFetchAll(() => PaymentGatewayAPI.getAllPaymentGateways()  )
// console.log('value',value?.data);
  const [isAddPaymentGateway,setIsAddPaymentGateway]=useState(false) 
  const [isConfirm,setIsConfirm]=useState(null) 
  
  const openCloseAddPaymentGatway = () => {
    setIsAddPaymentGateway((p)=>!p)
  };

  const closeAddPaymentGatway = () => {
    setIsAddPaymentGateway(false) 
    fetchAllData()  
  };

  const updateModal=async(data)=>{
    // console.log("data",data);
    
    setIsConfirm(data)
  }

  const updatePaymentGateway=async(data)=>{
    setIsConfirm(data)
    
    try {
      const res =await PaymentGatewayAPI.updatePaymentGateway({isActive:!isConfirm?.isActive},isConfirm._id)
      fetchAllData()  
    } catch (error) {
      
    }
   
  }


  
  
  return (
    <>
      <div
        className={`w-15 bg-[--bg-color] shadow-[--shadow 0px 2px 8px 0px] p-5 rounded-md`}
      >
        <div className="flex justify-between ">
          <p className="text-[1.5rem]">Payment Gateway Settings</p>
          <GradientButton
            label={isAddPaymentGateway ? "Close" : "Add"}
            onClick={() => openCloseAddPaymentGatway()}
          />
        </div>
        <div className="my-4">
          <AddNewPaymentGatway
            open={isAddPaymentGateway}
            close={closeAddPaymentGatway}
          />
          { value?.data?.map((data,i)=>(
            <div className="border rounded-lg p-3 my-3 flex gap-5 justify-between items-center">
            <p>{data?.name ||""}</p>
            <ToggleButton checked={data?.isActive||false} handleChange={()=>updateModal(data)}/>
          </div>
          ))
            
          }
        </div>
      </div>      

      <ConfirmPopup
          isOpen={Boolean(isConfirm)}
          onClose={() => setIsConfirm(null)}
          onDelete={() => updatePaymentGateway()}
          labels={{heading:"Are you sure?", paragraph:`Did you want to ${isConfirm?.isActive?'disable':'enable'}  Payment Gatway!`, button:"Yes"}}
        />   
    </>
  );
};

export default PaymentGateway;



const AddNewPaymentGatway = ({ open, close}) => {

  const handleSubmit=async(values)=>{
    try {
      const res=await PaymentGatewayAPI.createPaymentGateway(values)
      close && close()
    } catch (error) {
      
    }
  }
  if (open) {
    return (
      // <div className="border rounded-lg p-3 w-[100%]  my-4 flex gap-5 justify-between items-center">
      // </div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: null,
            isActive: false,
          }}
          onSubmit={(values) => {
            // console.log(values);
            handleSubmit && handleSubmit(values)
          }}
        >
          {({ handleChange, setFieldValue, values, handleSubmit }) => (
            <Form className="border rounded-lg p-3 w-[100%]  my-4 flex gap-5 justify-between items-center">
              <FormField
                label={"Application Name"}
                tooltip={"Name Of Application"}
                className={`w-[50%] flex-1`}
              >
                <TextInput
                  name="name"
                  type="text"
                  placeholder="Enter Payment Gatway Name"
                  onChange={handleChange}
                  value={values?.appName}
                  required={true}
                />
              </FormField>
              <FormField
                label={"Enable/Disable"}
                tooltip={
                  "If Enabled then Payment Gatway is active otherwise disabled!"
                }
                className={`w-[50%] flex-1`}
              >
                <ToggleButton 
                  checked={values.isActive} 
                  handleChange={(e)=>{
                    // console.log("kjkfjjf",Boolean(e.target.value));
                    setFieldValue("isActive",!Boolean(values.isActive))                    
                  }} 
                />
              </FormField>
              <GradientButton label={`Add`} onClick={handleSubmit}/>
            </Form>
          )}
        </Formik>
    );
  }
};